import { createContext } from "react";

/**
 * Mobile drawer state — ephemeral (resets on navigation), mobile only.
 */
const MobileLayoutContext = createContext<{
    isMenuOpen: boolean;
    setIsMenuOpen: (value: boolean) => void;
}>({
    isMenuOpen: false,
    setIsMenuOpen: () => {},
});

export default MobileLayoutContext;
